<template>
    <div class="flex fd-c jc-sb ai-fs p-30 pt-10 f-18 h-100p">

        <div class="flex fd-c w-100p jc-fs">
            <div class="mb-20 w-100p">
                <el-button size="small">返回</el-button>
            </div>

            <div class="w-100p">
                <div class="flex ai-c jc-fs">
                    <div class="info-title">年级：</div>
                    <div class="w-200">
                        <el-cascader v-model="val" :options="options2"
                            :props="{ expandTrigger: 'hover' }"></el-cascader>
                    </div>
                    <div class="info-title">班级名称：</div>
                    <div class="w-200">
                        <el-input v-model="classInfo.className" placeholder=""></el-input>
                    </div>
                </div>

                <div class="flex ai-c jc-fs">
                    <div class="info-title">班群号：</div>
                    <div class="w-200">
                        <el-input disabled v-model="classInfo.classNumber" placeholder=""></el-input>
                    </div>
                    <div class="info-title">班主任：</div>
                    <div class="w-200">
                        <el-input disabled v-model="val" placeholder=""></el-input>
                    </div>
                </div>

                <div class="flex ai-c jc-fs">
                    <div class="info-title">班级预设人数（上限500）：</div>
                    <div class="w-200">
                        <el-input-number v-model="classInfo.maxSize" :min="1" :max="10"></el-input-number>
                    </div>
                    <div class="info-title">加入班级人数：</div>
                    <div class="w-200">
                        <el-input disabled v-model="classInfo.currentSize" placeholder=""></el-input>
                    </div>
                </div>

                <div class="flex ai-c jc-fs">
                    <div class="info-title">班级类型：</div>
                    <div class="w-200">
                        <el-input disabled v-model="classInfo.classType" placeholder=""></el-input>
                    </div>
                    <div class="info-title">所属学校/组织：</div>
                    <div class="w-200">
                        <el-input disabled v-model="classInfo.schoolName" placeholder=""></el-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex w-100p jc-fe">
            <el-button @click="transferDialogOpen()" type="info" plain>班级转让</el-button>
            <el-button @click="disband()" type="danger" plain>解散班级</el-button>
            <el-button type="primary" plain>保存</el-button>
        </div>

        <el-dialog title="转让班级" :visible.sync="transferDialog" width="500px">
            <div class="mb-20 t-c">您可以将班级装让给其他任课老师，转让后您将自动退出此班级</div>

            <el-form label-width="60px">
                <el-form-item label="转让老师手机号：">
                    <el-input style="width: 300px;" v-model="transferTel" placeholder=""></el-input>
                </el-form-item>
            </el-form>

            <div class="flex jc-fe">
                <el-button type="primary" plain>转让</el-button>
                <el-button plain>取消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { queryUserInfo, findAllSchool, updateUserDetail, queryUserDetails } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
    name: 'classInfo',
    components: {

    },
    computed: {

    },
    data() {
        return {
            loading: false,

            transferDialog: false,
            val: "",

            classInfo: {},

            transferTel: "",

            options2: [
                {
                    value: '1',
                    label: '幼儿',
                    children: [
                        {
                            value: '11',
                            label: '小班',
                        },
                        {
                            value: '12',
                            label: '中班',
                        },
                        {
                            value: '13',
                            label: '大班',
                        }
                    ]
                },
                {
                    value: '2',
                    label: '小学',
                    children: [
                        {
                            value: '21',
                            label: '一年级',
                        },
                        {
                            value: '22',
                            label: '二年级',
                        },
                        {
                            value: '23',
                            label: '三年级',
                        },
                        {
                            value: '24',
                            label: '四年级',
                        },
                        {
                            value: '25',
                            label: '五年级',
                        },
                        {
                            value: '26',
                            label: '六年级',
                        },
                    ]
                },
                {
                    value: '3',
                    label: '初中',
                    children: [
                        {
                            value: '31',
                            label: '初一',
                        },
                        {
                            value: '32',
                            label: '初二',
                        },
                        {
                            value: '33',
                            label: '初三',
                        }
                    ]
                },
                {
                    value: '4',
                    label: '高中',
                    children: [
                        {
                            value: '41',
                            label: '高一',
                        },
                        {
                            value: '42',
                            label: '高二',
                        },
                        {
                            value: '43',
                            label: '高三',
                        }
                    ]
                },
                {
                    value: 'other',
                    label: '其他',
                },
            ]
        };
    },
    created() {
        let param = {}
        if (this.$route.query.param) {
            param = JSON.parse(decrypt(this.$route.query.param))
        }
        this.classInfo = param.classInfo || {};
    },
    mounted() {
    },
    methods: {

        open() {
        },

        transferDialogOpen() {
            this.transferDialog = true;
        },

        disband() {
            this.$confirm('确定要解散班级吗？', '提示', {
                confirmButtonText: '解散班级',
                cancelButtonText: '点错了',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '已成功解散班级!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消解散班级'
                });
            });
        },
    }
};
</script>

<style lang='scss' scoped>
.info-title {
    font-size: 18px;
    padding: 15px 20px 15px 0;
    width: 250px;
    text-align: right;
}
</style>
